import { Component, inject, InjectionToken } from '@angular/core';
import { RidDiceOverlay } from '../rid-dice-overlay/rid-dice-overlay';
import { RidExpressionOverlay } from '../rid-expression-overlay/rid-expression-overlay';

export const RID_MECHANIC_DEFAULT_BACKGROUND = new InjectionToken<boolean>('RID_MECHANIC_DEFAULT_BACKGROUND', {
  providedIn: 'root',
  factory: () => true,
});

@Component({
  selector: 'rid-mechanic-background',
  imports: [RidExpressionOverlay, RidDiceOverlay],
  templateUrl: './rid-mechanic-background.html',
  host: {
    class: 'contents',
  },
})
export class RidMechanicBackground {
  protected readonly showDefaultBackground = inject(RID_MECHANIC_DEFAULT_BACKGROUND);
}
